import type { BlueprintFontModifier } from '@/grove-blueprints/generated-types'

const FONT_TOKEN_CLASS: Record<BlueprintFontModifier['token'], string> = {
  display1: 'grove-typography-display-1',
  display2: 'grove-typography-display-2',
  display3: 'grove-typography-display-3',
  title1: 'grove-typography-title-1',
  title2: 'grove-typography-title-2',
  headline1: 'grove-typography-headline-1',
  headline2: 'grove-typography-headline-2',
  headline3: 'grove-typography-headline-3',
  bodyLarge: 'grove-typography-body-large',
  body: 'grove-typography-body',
  subhead: 'grove-typography-subhead',
  footnote: 'grove-typography-footnote',
  caption1: 'grove-typography-caption-1',
  caption2: 'grove-typography-caption-2',
  dollarInput: 'grove-typography-dollar-input',
  label: 'grove-typography-label',
  eyebrow: 'grove-typography-eyebrow',
}

export function resolveFontModifier(modifier: BlueprintFontModifier): string {
  return FONT_TOKEN_CLASS[modifier.token]
}
